module.exports = __webpack_public_path__ + "img/success-filled.31dbd614.svg";